import { Action } from 'redux';

import { isActionFactory } from '../../app/actions/isActionFactory';
import { IMetricInfo } from '../models/IMetricInfo';

export const HideMetricsBanner = 'HideMetricsBanner';
export const ResumeMetric = 'ResumeMetric';
export const ResumeMetricFromExplorer = 'ResumeMetricFromExplorer';
export const UpdateMetricsData = 'UpdateMetricsData';
export const UpdateMetricsDataSucceeded = 'UpdateMetricsDataSucceeded';
export const AutoUpdateMetricDataStop = 'AutoUpdateMetricDataStop';
export const ReplaceMetricDataRefreshList = 'ReplaceMetricDataRefreshList';

export interface UpdateMetricsDataAction extends Action {
  type: typeof UpdateMetricsData;
  metrics: string[];
}

export function updateMetricsData(metrics: IMetricInfo[]): UpdateMetricsDataAction {
  const ids = metrics.map(m => m.id);
  return {
    type: UpdateMetricsData,
    metrics: ids
  };
}

export function updateMetricsDataByIds(ids: string[]): UpdateMetricsDataAction {
  return {
    type: UpdateMetricsData,
    metrics: ids
  };
}

export interface UpdateMetricsDataSucceededAction extends Action {
  readonly metrics: ReadonlyArray<IMetricInfo>;
}

export function updateMetricsDataSucceeded(metrics: ReadonlyArray<IMetricInfo>): UpdateMetricsDataSucceededAction {
  return {
    type: UpdateMetricsDataSucceeded,
    metrics
  };
}

export interface ResumeMetricAction extends Action {
  metric: IMetricInfo;
  isOwner: boolean;
}

export function resumeMetric(metric: IMetricInfo, isOwner: boolean): ResumeMetricAction {
  return {
    type: ResumeMetric,
    metric,
    isOwner
  };
}

export interface ResumeMetricFromExplorerAction extends Action {
  metricId: string;
  isOwner: boolean;
}

export function resumeMetricFromExplorer(metricId: string, isOwner: boolean): ResumeMetricFromExplorerAction {
  return {
    type: ResumeMetricFromExplorer,
    metricId,
    isOwner
  };
}

export interface HideMetricsBannerAction {}

export function hideMetricsBanner(): HideMetricsBannerAction {
  return {
    type: HideMetricsBanner,
  };
}

export function autoUpdateMetricDataStop(): Action {
  return {
    type: AutoUpdateMetricDataStop
  };
}

export interface ReplaceMetricDataRefreshListAction extends Action {
  type: typeof ReplaceMetricDataRefreshList;
  ids: string[];
}

export function replaceMetricDataRefreshList(ids: string[]): ReplaceMetricDataRefreshListAction {
  return {
    type: ReplaceMetricDataRefreshList,
    ids
  };
}

export const isUpdateMetricsDataSucceededAction = isActionFactory<UpdateMetricsDataSucceededAction>(UpdateMetricsDataSucceeded);
